module.exports = __webpack_public_path__ + "img/info-dark.3bfeb89e.svg";